import { useEffect, useRef } from "react";
import { useColorMode } from "@chakra-ui/react";
import lottie, { AnimationItem } from "lottie-web";

const LottieLoader = () => {
  const container = useRef<HTMLDivElement>(null);
  const animationRef = useRef<AnimationItem | null>(null);
  const { colorMode } = useColorMode(); // light | dark

  useEffect(() => {
    if (!container.current) return;

    const animationPath = colorMode === "dark" ? "/lottie/white.json" : "/lottie/black.json";

    fetch(animationPath)
      .then((res) => res.json())
      .then((animationData) => {
        if (animationRef.current) {
          animationRef.current.destroy();
        }

        const anim = lottie.loadAnimation({
          container: container.current!,
          renderer: "svg",
          loop: true,
          autoplay: true,
          animationData,
        });

        animationRef.current = anim;
        animationRef.current.playSegments([0, 170], true);
      });

    return () => {
      if (animationRef.current) {
        animationRef.current.destroy();
        animationRef.current = null;
      }
    };
  }, [colorMode]); // <- re-run when theme changes

  return <div ref={container} />;
};

export default LottieLoader;
